class GoogleMapService {
  constructor($q, $rootScope, $http) {
    this.$q = $q;
    this.$rootScope = $rootScope;
    this.$http = $http;
  }
  // http://jsfiddle.net/danharper/Nve8Q/
  haversine(point1, point2) {
    var toRad = function(value) {
      return value * Math.PI / 180;
    };
    var R = 3959; // earth radius in mi
    var dLat = toRad(Number(point2.lat) - Number(point1.lat));
    var dLon = toRad(Number(point2.lng) - Number(point1.lng));
    var lat1 = toRad(point1.lat);
    var lat2 = toRad(point2.lat);

    var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
            Math.sin(dLon/2) * Math.sin(dLon/2) *
            Math.cos(lat1) * Math.cos(lat2);

    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    return R * c;
  }
  calculateHavDistance(origin, destinations) {
    var haversine = this.haversine;
    return destinations.map(function(destination) {
      destination.distance = haversine({ lat: destination.lat, lng: destination.lng }, origin);
      return destination;
    });
  }
  getLatLng(origin, destinations) {
    var haversine = this.haversine;
    return this.$http.get('https://maps.googleapis.com/maps/api/geocode/json?address=' +
      encodeURIComponent(origin)).then(function(response) {
        if(response.data.results.length) {
          return {
            lat: response.data.results[0].geometry.location.lat,
            lng: response.data.results[0].geometry.location.lng
          };
        } else {
          return [];
        }
    });
  }
  calculateDistance(origin, destination) {
    var deferred = this.$q.defer();
    let service = new google.maps.DistanceMatrixService();
    service.getDistanceMatrix({
      origins: [origin],
      destinations: this.stringifyAddresses(destination),
      travelMode: google.maps.TravelMode.DRIVING,
      unitSystem: google.maps.UnitSystem.IMPERIAL
    }, (response, status) => {
      if (status == google.maps.DistanceMatrixStatus.OK) {
        this.$rootScope.$apply(() => {
          let locations = destination;
          let results = response.rows[0].elements;
          for (let [index, location] of locations.entries()) {
            location.distance = results[index].distance.value;
          }
          deferred.resolve(locations);
        });
      }
    });
    return deferred.promise;
  }
  stringifyAddresses(addresses) {
    let locations = [];
    for (let address of addresses) {
      if (address.addressLine2) {
        locations.push(`${address.addressLine1}, ${address.addressLine2}, ${address.city}, ${address.stateAbbreviation} ${address.zipCode}`);
      } else {
        locations.push(`${address.addressLine1}, ${address.city}, ${address.stateAbbreviation} ${address.zipCode}`);
      }
    }
    return locations;
  }
  convertLocation(origin) {
    return this.$http.get('https://maps.googleapis.com/maps/api/geocode/json?latlng=' + origin.latitude + ',' + origin.longitude)
      .then(function(response) {
        if(response.data.results.length) {
          for(let component of response.data.results[0].address_components)
          {
              if(component.types[0] == "postal_code")
              {
                  var zipCode = (component.long_name);
              }
          }
          return {
            street: response.data.results[0].formatted_address,
            zip: zipCode
          };
        } else {
          return [];
        }
    });

  }
}

GoogleMapService.$inject = ['$q', '$rootScope', '$http'];

export default GoogleMapService;



// WEBPACK FOOTER //
// ./src/services/googlemap.service.js